var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 108.5,
    viewBox: "0 0 20 108.5",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 1.5v82",
    stroke: "#3453d9",
    strokeDasharray: "3 10",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 88.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 0a10 10 0 1 1 -10 10 10 10 0 0 1 10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 3c-3.85980988 0-7 3.14019012-7 7s3.14019012 7 7 7 7-3.14019012 7-7-3.14019012-7-7-7m0-3c5.52285004 0 10 4.47714996 10 10s-4.47714996 10-10 10-10-4.47714996-10-10 4.47714996-10 10-10z",
    fill: "#d9b334"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeline);
export default __webpack_public_path__ + "static/media/icon-timeline.cdb66fe71a7908168e69e1eb582addd5.svg";
export { ForwardRef as ReactComponent };